import { baseURL } from "../Config";
import axios from "axios";
import { toast } from "react-toastify";

export const handleGetRequest = async (url) => {
    if (!navigator.onLine) {
        // Handle the case when the network is off
        toast.error("No internet connection. Please check your network and try again.");
        return;
    }
    try {
        // const userToSend = "zbiz";
        // const passToSend = "@zbiz!123";
        // const encryptedUsername = handleEncryptData(userToSend);
        // const encryptedPassword = handleEncryptData(passToSend);
        const response = await axios.get(`${baseURL + url}`, {
            headers: {
                Authorization: localStorage.getItem("token"),
                // username: encryptedUsername,
                // password: encryptedPassword
            },
        });
        return response.data;
    } catch (error) {
        if (error?.response?.data?.message === 'Session Expired') {
            console.log('error.response.data.messages', error.response.data.messages)
            localStorage.clear();
            setTimeout(() => {
                window.location.href = '/';
            }, 1000);
        }
        const id = toast.loading("Please wait...");
        if (error?.response?.status === 500) toast.update(id, { render: error?.response?.data?.messages || "Something went wrong !!", type: "error", isLoading: false, autoClose: 3000 });
        else toast.update(id, { render: error?.response?.data?.messages || "Something went wrong !!", type: "warn", isLoading: false, autoClose: 3000 });
    }
};
